import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Head from 'next/head';
import styled from 'styled-components';
import { getColor, getSpace } from '@yoweb/ui/styles/utils/theme';
import { ToastContextProvider } from '@yoweb/ui/contexts/toast/ToastContext';
import { LogoAnchor } from '@yoweb/ui/components/LogoAnchor';
import { PAGE_HOME } from '@poplar/constants/routes';
import { Box } from '@yoweb/ui/components/Box';
import { media } from '@yoweb/ui/styles/utils';
import { TaskProvider } from '@poplar/contexts/TaskContext/TaskProvider';
import { AblyProvider } from '@poplar/contexts/AblyContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/**
 * Primary layout component for member introduction pages.
 */
export var IntroductionLayout = function IntroductionLayout(_ref) {
  var children = _ref.children,
      background = _ref.background;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      })
    }), /*#__PURE__*/_jsx(AblyProvider, {
      children: /*#__PURE__*/_jsx(ToastContextProvider, {
        defaultPosition: "bottom-right",
        children: /*#__PURE__*/_jsx(TaskProvider, {
          children: /*#__PURE__*/_jsx(IntroductionLayoutContainer, {
            background: background,
            children: /*#__PURE__*/_jsxs(Box, {
              position: "relative",
              pt: {
                _: 'large1',
                md: 'large3'
              },
              children: [/*#__PURE__*/_jsx(LogoAnchorContainer, {
                children: /*#__PURE__*/_jsx(LogoAnchor, {
                  href: PAGE_HOME
                })
              }), children]
            })
          })
        })
      })
    })]
  });
};
var LogoAnchorContainer = styled.div.withConfig({
  componentId: "sc-lxdwuk-0"
})(["position:absolute;top:0;left:calc(50% - 95px / 2);"]);
var IntroductionLayoutContainer = styled.div.withConfig({
  componentId: "sc-lxdwuk-1"
})(["background:", ";min-height:100vh;padding:", ";display:grid;", ""], function (_ref2) {
  var background = _ref2.background;
  return background ? background : getColor('sandLight');
}, getSpace('normal2'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n  "])), getSpace('normal2'), getSpace('large2')));
export var getIntroductionLayout = function getIntroductionLayout(page, props) {
  return /*#__PURE__*/_jsx(IntroductionLayout, _objectSpread(_objectSpread({}, props), {}, {
    children: page
  }));
};
export default IntroductionLayout;